import { CreditCard, Trash2, Star } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import type { PaymentMethod } from '@/hooks/usePayment';

interface PaymentMethodCardProps {
  method: PaymentMethod;
  onDelete: (id: string) => void;
  onSetDefault: (id: string) => void;
}

function getCardIcon(brand?: string) {
  switch (brand?.toLowerCase()) {
    case 'visa':
      return 'VISA';
    case 'mastercard':
      return 'MC';
    case 'amex':
      return 'AMEX';
    case 'discover':
      return 'DISC';
    default:
      return brand?.toUpperCase() || 'CARD';
  }
}

export function PaymentMethodCard({ method, onDelete, onSetDefault }: PaymentMethodCardProps) {
  return (
    <Card className="glass">
      <CardContent className="p-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-10 w-14 rounded bg-primary/10 flex items-center justify-center text-xs font-bold text-primary">
            {getCardIcon(method.brand)}
          </div>
          <div>
            <p className="text-sm font-medium">
              {method.brand ? method.brand.charAt(0).toUpperCase() + method.brand.slice(1) : 'Card'}
              {' '}ending in {method.last4 || '****'}
            </p>
            <p className="text-xs text-muted-foreground">
              Expires {method.expMonth?.toString().padStart(2, '0') || '**'}/{method.expYear || '****'}
            </p>
            {method.isDefault && (
              <Badge variant="secondary" className="mt-1 text-xs">
                <Star className="h-3 w-3 mr-1" />
                Default
              </Badge>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {!method.isDefault && (
            <Button variant="ghost" size="sm" onClick={() => onSetDefault(method.id)}>
              <Star className="h-4 w-4" />
            </Button>
          )}
          <Button variant="ghost" size="sm" onClick={() => onDelete(method.id)}>
            <Trash2 className="h-4 w-4 text-destructive" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
